export const content = {
  title: "Campaign Insights",
  filterLabel: "Campaigns",
  subtitle:
    "Break down your marketing campaigns by spend, revenue and ROI. Identify high and low performing campaigns to unlock new insights.",
};

export const noDataContent = {
  title: "Insufficient Data",
  description:
    "Sorry, there is not enough data to show this module. Try selecting a difference business unit or adjusting your date range.",
};
